import { COLORS } from '@dehaat/dds';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { useAppSelector } from '@/hooks/reduxHooks';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { selectCurrentVendor, selectCurrentVendorId } from '@/store/features/locationSlice';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import { replaceUrlHost } from '@/utils/helper';
interface Props {
  deepLink: string;
  color?: string;
  text?: string;
  className?: string;
  bgColor?: string;
  componentName?: string;
  componentId?: string | number;
}
const ViewAllButton = ({
  text = 'View All',
  color,
  deepLink,
  className = '',
  bgColor = 'white',
  componentName = '',
  componentId = ''
}: Props) => {
  const {
    t
  } = useTranslation('main');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const vendorId = useAppSelector(selectCurrentVendorId);
  const vendorDetails = useAppSelector(selectCurrentVendor);
  const eventParams = {
    ComponentName: componentName,
    ComponentId: componentId,
    VendorName: vendorDetails?.company_name,
    VendorId: vendorId
  };
  return <Link onClick={() => {
    trackCustomEvent(CustomEventTypes.USER_CLICKED_PRODUCT_LISTING_VIEW_ALL, JSON.stringify(eventParams));
  }} href={replaceUrlHost(deepLink)} className={`flex justify-center px-12 py-2.5 mt-6 rounded-lg max-w-[350px] m-auto bg-white border border-neutral-20 ${className}`} style={{
    backgroundColor: bgColor
  }} data-sentry-element="Link" data-sentry-component="ViewAllButton" data-sentry-source-file="ViewAllButton.tsx">
      <p className="text-center font-nato-semibold" style={{
      color: color || COLORS.primary100
    }}>
        {text || t('view_all')}
      </p>
    </Link>;
};
export default ViewAllButton;